// API Configuration
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Legacy function for backwards compatibility
// Note: This uses environment variables directly
// For authenticated requests, use AuthContext.getAuthHeaders() instead
export const getAuthHeaders = () => {
  const API_USERNAME = process.env.REACT_APP_API_USERNAME || 'admin';
  const API_PASSWORD = process.env.REACT_APP_API_PASSWORD || 'sslmonitor123';
  const credentials = btoa(`${API_USERNAME}:${API_PASSWORD}`);
  return {
    'Authorization': `Basic ${credentials}`,
    'Content-Type': 'application/json'
  };
};
